<template>
  <Nextgrid apiurl="VisionNextStockManagement/api/StockAdjustment/Search" :andConditionalModel="model" />
</template>
<script>
export default {
  data () {
    return {
      model: {
        MovementTypeIds: [6]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/StockAdjustment/index.vue